export default "__VITE_ASSET__Bg5CX$Al__"